import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { ITypeDefLookup, LookupCriteria } from "@tylertech/tyler-api-types";
import { ICostCategoryCode } from "../interfaces";
@Injectable()
export class CostCategoryCodeService
{
    constructor(
        private readonly $apiService: ApiService
    ) { }

    GetCostCategoryChargeTypes(): Promise<ITypeDefLookup[]>
    {
        return this.$apiService.sendAuth("ICostCategoryCodeService/GetCostCategoryChargeTypes");
    }

    GetCostCategoryCode(id: string): Promise<ICostCategoryCode>
    {
        return this.$apiService.sendAuth("ICostCategoryCodeService/GetCostCategoryCode", id);
    }

    GetCostCategoryCostTypes(): Promise<ITypeDefLookup[]>
    {
        return this.$apiService.sendAuth("ICostCategoryCodeService/GetCostCategoryCostTypes");
    }

    GetCostCategoryTypes(): Promise<ITypeDefLookup[]>
    {
        return this.$apiService.sendAuth("ICostCategoryCodeService/GetCostCategoryTypes");
    }

    Lookup(pCriteria: LookupCriteria): Promise<ICostCategoryCode[]>
    {
        return this.$apiService.sendAuth("ICostCategoryCodeService/LookupCostCategoryCode", pCriteria);
    }
}
